module.exports = __webpack_public_path__ + "img/lancome_handle.0a4efd90.svg";